// Card rarity metadata — single source of truth for labels, text colors,
// and full badge styles (background + border + text).
// Used by GameSettingsPanel (rarity toggles), DraftPicksColumn, and any
// future surface that needs to color-code cards by rarity.

export const RARITY_OPTIONS = [
  { key: "common",   label: "Common",   color: "text-slate-300" },
  { key: "rare",     label: "Rare",     color: "text-blue-400"  },
  { key: "iconic",   label: "Iconic",   color: "text-amber-400" },
  { key: "junk_wax", label: "Junk Wax", color: "text-slate-500" },
];

// Full badge styling (background + border + text) — used in draft pick chips
// and any compact rarity tag. Keys cover all rarities in the card pool.
export const RARITY_BADGE_STYLE = {
  common:    { label: "Common",    classes: "bg-slate-700/60 border-slate-600 text-slate-200" },
  uncommon:  { label: "Uncommon",  classes: "bg-emerald-500/15 border-emerald-500/40 text-emerald-300" },
  rare:      { label: "Rare",      classes: "bg-blue-500/20 border-blue-500/40 text-blue-300" },
  iconic:    { label: "Iconic",    classes: "bg-amber-500/20 border-amber-500/40 text-amber-300" },
  legendary: { label: "Legendary", classes: "bg-purple-500/20 border-purple-500/40 text-purple-300" },
  exclusive: { label: "Exclusive", classes: "bg-orange-500/20 border-orange-500/40 text-orange-300" },
  junk_wax:  { label: "Junk Wax",  classes: "bg-slate-800 border-slate-700 text-slate-400" },
};

export function rarityBadgeStyle(rarity) {
  return RARITY_BADGE_STYLE[rarity] || { label: rarity || "—", classes: "bg-slate-800 border-slate-700 text-slate-400" };
}
